import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
export function TeamSection() {
  const team = [{
    name: 'Christian Holland',
    title: 'Founder | CEO',
    image: 'https://cdn.magicpatterns.com/uploads/kz9y3ExV3Yk322gpQu5dWa/C03D4C47-5A83-4A7F-BD5D-4FE715B54449.jpg',
    bio: 'Christian started his career as a medical doctor, gaining degrees from the University of Oxford before co-founding his first ed-tech startup Appli. He was employee #3 at a startup acquired by defense unicorn Metrea, and was later Chief of Staff at Metrea. Christian leads business developement at Pimlico and has also written a chunk of the codebase.',
    linkedin: 'https://www.linkedin.com/in/christianmaholland/',
    email: 'christian@pimlicotrading.com'
  }, {
    name: 'Lydia Field',
    title: 'Founder | CTO',
    image: 'https://cdn.magicpatterns.com/uploads/37FZtfeQcy6SAZCXGgVfr2/Screenshot_2024-11-12_at_21.32.26.jpg',
    bio: 'Lydia is an economist by training, with degrees from the University of Oxford and UCL. She previously worked as an economic consultant for Frontier Economics, leveraging data-science to advise billion-dollar companies on questions of regulation, competition, and market strategy. Since founding Pimlico Trading she has written (and re-written) most of the codebase; she also manages operations and shares sales with Christian.',
    linkedin: 'https://www.linkedin.com/in/lydia-field-0387b3137/',
    email: 'lydia@pimlicotrading.com'
  }];
  return <section id="team" className="relative bg-[#fafafa] py-32 md:py-40 px-7 md:px-40" data-id="element-113">
      {/* Subtle top gradient transition from dark section */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1a1a1a] to-transparent pointer-events-none opacity-30" data-id="element-114" />

      <div className="max-w-6xl mx-auto" data-id="element-115">
        <div className="mb-24 max-w-4xl mx-auto px-8" data-id="element-116">
          <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4 text-left" data-id="element-117">
            Our Team
          </p>
          <h2 className="text-4xl md:text-6xl font-light text-[#1a1a1a] text-center" data-id="element-118">
            Founding Team
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-119">
          {team.map(member => <div key={member.name} className="group" data-id="element-120">
              <div className="bg-white p-8 md:p-12 shadow-sm border border-gray-100 h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1" data-id="element-121">
                <div className="flex flex-col h-full" data-id="element-122">
                  {/* Headshot */}
                  <div className="mb-6" data-id="element-123">
                    <img src={member.image} alt={member.name} className="w-24 h-24 object-cover border-4 border-[#f0f5f9] shadow-md" data-id="element-124" />
                  </div>

                  <div className="mb-6" data-id="element-125">
                    <h3 className="text-2xl font-semibold text-[#1a1a1a] mb-2" data-id="element-126">
                      {member.name}
                    </h3>
                    <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f]" data-id="element-127">
                      {member.title}
                    </p>
                  </div>

                  <p className="text-gray-600 leading-relaxed mb-8 flex-grow" data-id="element-128">
                    {member.bio}
                  </p>

                  <div className="flex space-x-4 pt-6 border-t border-gray-100" data-id="element-129">
                    <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#1e3a5f] transition-colors" data-id="element-130">
                      <Linkedin size={20} data-id="element-131" />
                    </a>
                    <a href={`mailto:${member.email}`} className="text-gray-400 hover:text-[#1e3a5f] transition-colors" data-id="element-132">
                      <Mail size={20} data-id="element-133" />
                    </a>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}